import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@chakra-ui/react'
/**
 * @typedef {Object} PDCHeaderTopBannerProps
 * @property {string} smallMessage - Small message.
 * @property {string} mediumMessage - Medium message.
 * @property {string} largeMessage - Large message.
 * @returns {React.ReactElement} - PDCHeaderTopBanner component.
 */
export const PDCShippingPDPDetailsPD = ({title, text}) => {
    return (
        <>
            <Text
                role="heading"
                aria-level="3"
                fontWeight={'normal'}
                fontSize={'md'}
                textTransform={'uppercase'}
                mb={'10px'}
            >
                {title}
            </Text>
            <Text fontSize={'md'} color={'darkGray'} mb={'10px'}>
                {text}
            </Text>
        </>
    )
}
PDCShippingPDPDetailsPD.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string
}
